import PropTypes from 'prop-types';
import React from 'react';
import { decodeXml } from '../utils/encodeXML.ts';

export let SavedSearch = ({ search, baseSearchURL }) => {
    const newResults = search.newResults > 999 ? '999+' : search.newResults;
    const newResultsLink = baseSearchURL +
        new Uri(search.searchURL).replaceQueryParam('newSince', search.lastViewed).query();
    // We double encode the markers that separate each criterion in the description,
    // and we single encode values within each criterion.
    const descriptionParts = decodeXml(search.searchDesc).split(' &gt; ');
    const firstCriterion = descriptionParts[0];
    const otherCriteria = descriptionParts.slice(1).join(', ');

    return <a tabIndex="0" role="button" aria-label={'View saved search for ' + firstCriterion + ' ' + otherCriteria} className="saved-search" href={newResultsLink}>
        <div className="title-wrapper">
            <span className="title">{firstCriterion}</span>
            {' '}<span className={'new-search-results ' + (parseInt(newResults) == 0 ? 'zero' : '')}>{newResults}&nbsp;new</span>
        </div>
        {otherCriteria != '' ? <div className="subtitle">{otherCriteria}</div> : ''}
    </a>;
};
SavedSearch.propTypes = {
    search: PropTypes.object.isRequired,
    baseSearchURL: PropTypes.string.isRequired,
};
SavedSearch = React.memo(SavedSearch);
